import { useMemo } from 'react'

import { Alert } from '@vtex/shoreline'

import Loading from '~/components/Loading'
import { LogoStore } from '~/components/LogoStore'
import { FormGroup, Label } from '~/components/unform'
import { CheckboxList } from '~/components/unform/CheckboxList'
import { capitalizeWords } from '~/helpers/capitalize-words'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

const SubpublishersRadioList: React.FC<SubpublishersRadioListProps> = ({
  label = null,
  selectedPublishers,
  onChange,
  data,
  isPending,
  hasSearchTerm = false
}) => {
  const { t } = useAPPTranslation()

  /**
   * Format select options
   */

  const subpublishers: CheckboxOptionProps[] = useMemo(() => {
    const publishers = data?.data.filter(
      item => !selectedPublishers?.includes(item.id)
    )

    const formattedPublishers = publishers?.map(item => ({
      id: item.id,
      name: `${item.id}`,
      value: item.id,
      label: capitalizeWords(item.name),
      disabled: selectedPublishers?.includes(item.id),
      icon: (
        <LogoStore
          alt={item.name}
          linkLogo={item.account_logo}
          backgroundLogo={item.account_theme?.header_color}
          size="small"
        />
      )
    }))

    return formattedPublishers
  }, [data?.data, selectedPublishers])

  return (
    <FormGroup className="flex-fill">
      {label && <Label htmlFor="subpublisher_ids" isRequired text={label} />}

      <Loading status={isPending}>
        {t('rm:campaign.create.Subpublishers.loading')}
      </Loading>

      {selectedPublishers && !subpublishers?.length && (
        <Alert variant="warning" className="mb-2">
          {hasSearchTerm
            ? t('rm:campaign.subpublishers.search.notFound')
            : t('rm:campaign.subpublishers.add.alert.alreadySelectAll')}
        </Alert>
      )}

      <CheckboxList
        options={subpublishers}
        name="subpublisher_ids"
        onChange={onChange}
      />
    </FormGroup>
  )
}

export default SubpublishersRadioList
